import { useCallback, useEffect, useState } from "react";
import { io } from "socket.io-client";

export default function useSocketClient(url, token, options) {
  const [socket, setSocket] = useState(null);

  useEffect(() => {  
    if (!url || !token) return;

    console.log('Creating new socket')
    const newSocket = io(
      url, 
      { 
        ...options,
        path: '/file-converter/',
        autoConnect: false,
        extraHeaders: {
          "client-type": 'user',
          authorization: `Bearer ${token}`
        }
      }
    );

    setSocket(newSocket);
    newSocket.connect();

    return () => {
      newSocket?.disconnect();
      setSocket(null);
    }
  }, [url, token, options])

  const emit = useCallback((event, message) => {
    if (!socket) return;

    socket.emit(event, message);
  }, [socket])

  const on = useCallback((event, func) => {
    if (!socket) return;

    socket.on(event, func);
    return () => socket.off(event, func);
  }, [socket])


  return { socket, on, emit };
}